// Temporary endless-mode rule: Mars Colony has no victory/end condition.
// Defeat/failure rules remain active. If old saves or legacy simulation code
// set victory=true, clear it immediately so simulation continues indefinitely.

import { useGame } from "../em2c-store";

let unsubscribe = null;

export function installEndlessGameIntegration() {
  if (unsubscribe) return () => {};

  const clearVictory = (state = useGame.getState()) => {
    if (state?.victory) useGame.setState({ victory: false });
  };

  clearVictory();
  unsubscribe = useGame.subscribe((state) => clearVictory(state));

  return () => {
    unsubscribe?.();
    unsubscribe = null;
  };
}
